import { createContext } from "react";

import type { AdminRequestOptions, AdminUser } from "./types";

export interface AdminSessionContextValue {
  user: AdminUser | null;
  accessToken: string | null;
  isReady: boolean;
  isAuthenticated: boolean;
  login: (identifier: string, password: string, acceptTerms: boolean) => Promise<void>;
  updateProfile: (input: { firstName: string; lastName: string; email: string }) => Promise<void>;
  changePassword: (input: { currentPassword: string; newPassword: string }) => Promise<void>;
  logout: () => Promise<void>;
  request: <T>(path: string, options?: AdminRequestOptions) => Promise<T>;
}

export const AdminSessionContext = createContext<AdminSessionContextValue | null>(null);
